export default __webpack_public_path__ + "static/media/lbnmas-logo.dc9e663e.png";